import { render } from "./BigAmount.vue?vue&type=template&id=d6f7b4b8"
import script from "./BigAmount.vue?vue&type=script&lang=ts"
export * from "./BigAmount.vue?vue&type=script&lang=ts"
script.render = render

export default script